<div class="main-container">
    <p>คำค้นหายอดนิยม</p>
    <div class="skeleton" [style]="{'width': width}" [ngClass]="{'hidden': !loading}">
        <p-skeleton *ngFor="let i of [1, 2, 3, 4, 5]" height="8vh" width="10vw"></p-skeleton>
    </div>
    <div class="keyword-container" [ngClass]="{'hidden': loading}" [style]="{'width': width}">
        <button *ngFor="let keyword of keywords" (click)="onKeywordClick(keyword)">{{ keyword }}</button>
    </div>
</div>